import React from "react"

export function DesignPreviewModal({ previewDesign, designThumbnails, onLoadDesign, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
        <div className="p-4 border-b border-gray-200 bg-gray-50">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold text-gray-900">{previewDesign.name || "Untitled Design"}</h2>
              <p className="text-sm text-gray-600 mt-1">
                Created by: {previewDesign.createdByName || previewDesign.createdBy} • {previewDesign.elements?.length || 0} elements
                {previewDesign.isPreferred && (
                  <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    ✓ Submitted to Studio
                  </span>
                )}
              </p>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        <div className="p-6 overflow-y-auto max-h-[70vh] flex justify-center">
          <div className="bg-gray-100 p-4 rounded-lg">
            {designThumbnails[previewDesign.id] ? (
              <img
                src={designThumbnails[previewDesign.id]}
                alt={`Preview of ${previewDesign.name || "design"}`}
                className="max-w-full max-h-[60vh] object-contain rounded border border-gray-300 shadow-lg"
              />
            ) : (
              <div className="w-96 h-64 bg-gray-200 rounded border border-gray-300 flex items-center justify-center">
                <div className="text-gray-500">Generating preview...</div>
              </div>
            )}
          </div>
        </div>
        <div className="p-4 border-t border-gray-200 bg-gray-50">
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-600">
              Last updated:{" "}
              {previewDesign.updatedAt?.toDate ? previewDesign.updatedAt.toDate().toLocaleString() : "Unknown"}
            </div>
            <div className="flex space-x-3">
              <button
                onClick={() => onLoadDesign(previewDesign.id)}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
              >
                Load to Canvas
              </button>
              <button
                onClick={onClose}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

